export const moveAnimationStrategy = (action) => ({
  left: action.to?.x !== undefined ? action.to.x + "%" : undefined,
  top: action.to?.y !== undefined ? action.to.y + "%" : undefined,
});

export const fadeAnimationStrategy = (action) => ({
  opacity: action.to?.opacity ?? 1,
});

export const scaleAnimationStrategy = (action) => ({
  scale: action.to?.scale ?? 1,
});

export const rotateAnimationStrategy = (action) => ({
  rotation: action.to?.rotation ?? 0,
});